import React, { useCallback, useContext } from 'react';
import { Box } from '@src/atoms/Box';
import { Dialog } from '@src/atoms/Dialog';
import { Unit } from '@src/core/Unit';
import { Button } from '@src/atoms/Button';
import { BreakpointsContext } from '@src/providers/Breakpoints';
import { AppContext } from '@src/providers/App';
import { ERROR_REASON_NOTIFICATIONS } from '@src/molecules/DemoForm/const';
import { Tag } from '@src/atoms/Tag';
import { getDemoCredentials } from '@src/molecules/DemoForm/utils';
import { TDevelopmentMode } from '@src/providers/App/models';

export const DemoForm = ({ open, onClose }) => {
  const { isMobile } = useContext(BreakpointsContext);
  const { ngApiClient, setNotification, mode } = React.useContext(AppContext);
  const [demoRole, setDemoRole] = React.useState<'GMR' | 'GMA' | ''>('');
  const CREDENTIALS = getDemoCredentials(mode as TDevelopmentMode);

  const handleSubmit = useCallback(async () => {
    if (!demoRole) {
      setNotification(ERROR_REASON_NOTIFICATIONS['DEFAULT_ERROR']);
      return;
    }
    try {
      await ngApiClient.login(CREDENTIALS[demoRole]);
      setDemoRole('');
    } catch (error) {
      setNotification(ERROR_REASON_NOTIFICATIONS['DEFAULT_ERROR']);
      setDemoRole('');
    }
  }, [ngApiClient, setNotification, demoRole]);

  const handleClose = useCallback(() => {
    setDemoRole('');
    onClose();
  }, [onClose]);

  const handleGmrClick = useCallback(() => {
    setDemoRole('GMR');
  }, []);

  const handleGmaClick = useCallback(() => {
    setDemoRole('GMA');
  }, []);

  return (
    <Unit id={'DemoForm'}>
      <Box>
        <Dialog disableCloseBtn={false} id="DemoFormDialog" open={open} onClose={handleClose}>
          <Dialog.Header content="Выберите роль для просмотра" />
          <Box column>
            <Box gap={4} marginBottom={20} marginTop={24}>
              <Tag id="DemoFormGmrTag" size="lg" selected={demoRole === 'GMR'} clickable onClick={handleGmrClick}>
                Бренд товаров и услуг
              </Tag>
              <Tag id="DemoFormGmaTag" size="lg" selected={demoRole === 'GMA'} clickable onClick={handleGmaClick}>
                Рекламное агентство
              </Tag>
            </Box>
            <Box marginTop={16} justifyContent={'spaceBetween'}>
              <Button
                disabled={!['GMR', 'GMA'].includes(demoRole)}
                id="OpenDemoBtn"
                view="primaryLight"
                size="md"
                fullWidth={isMobile}
                onClick={handleSubmit}
              >
                Открыть деморежим
              </Button>
              <Button onClick={handleClose} id="CloseDemoBtn" view="textLight" size="md" fullWidth={isMobile}>
                Отмена
              </Button>
            </Box>
          </Box>
        </Dialog>
      </Box>
    </Unit>
  );
};
